// Spam Rules search predicate — extracted to its own file (rather than
// inline in SpamRulesView.jsx) purely so it's unit-testable: this project's
// plain `node --test` runner has no JSX transform, so a .jsx file can never
// be imported from a node:test file even for a JSX-free helper function
// defined inside it. Mirrors templateSearch.js's style.

// Matches on shortId/name (the row's identity) plus fromPatterns/
// subjectPatterns/bodyPattern/category (the rule's actual matching content
// and label) — all can be empty/null for a rule that doesn't use that
// condition, same null-safety as matchesTemplateSearch(). fromPatterns/
// subjectPatterns are lists — matches if the query is found in ANY ONE of
// the values.
export function matchesSpamRuleSearch(rule, query) {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return Boolean(
    (rule.shortId ?? '').toLowerCase().includes(q) ||
    (rule.name ?? '').toLowerCase().includes(q) ||
    (rule.fromPatterns ?? []).some((p) => p.toLowerCase().includes(q)) ||
    (rule.subjectPatterns ?? []).some((p) => p.toLowerCase().includes(q)) ||
    (rule.bodyPattern ?? '').toLowerCase().includes(q) ||
    (rule.category ?? '').toLowerCase().includes(q)
  )
}
